import { Component, Input, OnInit } from '@angular/core';
import { EthWalletService } from 'src/app/services/eth-wallet.service';

@Component({
  selector: 'app-trades',
  templateUrl: './trades.component.html',
  styleUrls: ['./trades.component.scss']
})
export class TradesComponent implements OnInit {
  @Input() trades: any[] = [];
  @Input() showAccount = false;

  constructor(public ethWalletService: EthWalletService) {}

  ngOnInit(): void {}
}
